import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
  Text,
  Alert,
  AlertIcon,
  Select,
  useColorModeValue,
} from '@chakra-ui/react';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    role: 'user', // Default role
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { register, error } = useAuth();
  const navigate = useNavigate();
  
  const bgColor = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const success = await register(formData);
    
    setIsSubmitting(false);
    
    if (success) {
      navigate('/login');
    }
  };

  return (
    <Box 
      p={8}
      maxWidth="500px"
      mx="auto"
      mt={10}
      bg={bgColor}
      borderWidth="1px"
      borderRadius="lg"
      borderColor={borderColor}
      boxShadow="lg"
    >
      <VStack spacing={4} align="stretch">
        <Heading as="h1" size="lg" textAlign="center">Register</Heading>
        
        {error && (
          <Alert status="error" borderRadius="md">
            <AlertIcon />
            {error}
          </Alert>
        )}
        
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>

            <FormControl id="email">
              <FormLabel>Email</FormLabel>
              <Input 
                type="email" 
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </FormControl>
            
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <Input 
                type="password" 
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl id="username" isRequired>
              <FormLabel>Username</FormLabel>
              <Input 
                type="text" 
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </FormControl>
            
            <FormControl id="role">
              <FormLabel>Role</FormLabel>
              <Select 
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                <option value="user">User</option>
                <option value="expert">Expert</option>
                <option value="super_expert">Super Expert</option>
                {/* Admin role should be assigned manually by another admin */}
              </Select>
            </FormControl>
            
            <Button 
              colorScheme="blue" 
              width="full" 
              type="submit"
              isLoading={isSubmitting}
              loadingText="Creating Account"
            >
              Register
            </Button>
          </VStack>
        </form>
        
        <Text textAlign="center">
          Already have an account?{' '}
          <Link to="/login" style={{ color: 'blue.500' }}>
            Login
          </Link>
        </Text>
      </VStack>
    </Box>
  );
};

export default Register;